import Registration from './modules/Registration';
import Results from './modules/Results';
import Minutes from './modules/Minutes';
import Contact from './modules/Contact';
import Profile from './modules/Profile';
import Awards from  './modules/Awards';
import Events from  './modules/Events';
import MenuIcon from  './modules/DYS_Menu';
import Members from  './modules/Members';
import GoogleMap from './modules/GoogleMap';
import Reps from  './modules/Reps';
import User from  './modules/User';
import Message from  './modules/Message';
import Colours from  './modules/Colours';
import Documents from  './modules/Documents';
import Bursary from  './modules/Bursary';
import FeeAnalysis from  './modules/FeeAnalysis';
import AnnualReg from  './modules/AnnualReg';

var registration = new Registration();
var results = new Results();
var minutes = new Minutes();
var contact = new Contact();
var profile = new Profile();
var awards = new Awards();
var events = new Events();
var dys_menu = new MenuIcon();
var googleMap = new GoogleMap();
var reps = new Reps();
var user = new User();
var message = new Message();
var members = new Members();
var colours = new Colours();
var documents = new Documents();
var bursary = new Bursary();
var feeAnalysis = new FeeAnalysis();
var annualReg = new AnnualReg();
